import React, { createContext, useContext, useState, useCallback } from "react";

const AbortControllerContext = createContext();

export const AbortControllerProvider = ({ children }) => {
  const [controller, setController] = useState(new AbortController());

  const resetController = useCallback(() => {
    controller.abort();
    setController(new AbortController());
  }, [controller]);

  return (
    <AbortControllerContext.Provider
      value={{ signal: controller.signal, resetController }}
    >
      {children}
    </AbortControllerContext.Provider>
  );
};

export const useAbortController = () => {
  const context = useContext(AbortControllerContext);
  if (!context) {
    throw new Error(
      "useAbortController must be used within an AbortControllerProvider"
    );
  }
  return context;
};
